export const business_en = {
  feed_empty_title: "Nothing yet",
  feed_empty_desc: "Be the first to add something to the feed",

  menu_home: "Home",
  menu_calendar: "Calendar",
  menu_tasks: "Tasks",
  menu_info: "Info",
  menu_members: "Members",

  feed_edit_item: "Edit item...",
  feed_mention_tip: "Tip: Use @ and # to trigger mentions",
  feed_intro_text: "Joined and completed their profile! 🎉",
  feed_task_status_updated: "Completed this task",
  feed_share_text: "Share something with the group...",
  feed_media: "Media",
  feed_shoutout: "Shoutout",
  feed_post: "Post",
  feed_image_preview: "Image preview",

  manage_sheet_more: "More",
  manage_sheet_like: "Like",
  manage_sheet_edit: "Edit",
  manage_sheet_add_pin: "Set as Pinned",
  manage_sheet_remove_pin: "Remove as Pinned",
  manage_sheet_show: "Show",
  manage_sheet_hide: "Hide",
  manage_sheet_delete: "Delete",
  manage_sheet_report: "Report",

  feed_reactions: "Reactions",
  feed_content_hidden: "This content is hidden...",
  feed_content_deleted: "This content is deleted...",
  feed_content_reported: "This content is reported...",
  feed_comment: "Comment",
  feed_like: "Like",
  feed_load_comments: "Load more comments",
  feed_add_comment: "Add comment...",
  feed_replies: "replies",
  feed_reply: "Reply",
  feed_content_edited: "Edited...",
  feed_edit_comment: "Edit comment...",
  feed_load_replies: "Load more replies",
  feed_reply_now: "Reply...",
  feed_edit_reply: "Edit reply...",
  date_due: "Due",
  date: "Date",
  description: "Description",
  save: "Save",
  completed: "Completed",
  completed_this: "completed this",
  completed_this_total: "In total {{count}} have completed this",
  skipped_this_total: "({{count}} 'Not for me')",
  completed_this_total_one: "In total {{count}} has completed this",
  edit: "Edit",
  delete: "Delete",
  include_user: "Include",
  exclude_user: "Exclude",
  completed_by_everyone: "Completed by everyone",
  completed_by_count: "Completed by",
  you_have_completed_this: "You have completed this",
  you_set_as_completed: "Set as completed",
  you_have_skipped_this: "Currently set as 'Not for me'",
  set_task_as_skipped_title: "Task will be set as done, but not as completed.",
  set_task_as_skipped_desc: "You can at any time change your mind.",
  skipped_this: "Not for me",
  task_this_is_not_for_me: "This is not for me...",
  tasks_progress_summary:
    "You have completed {{completed}}/{{total}} tasks ({{percentage}}%)",
  show_completed_tasks_one: "Show my {{count}} completed task",
  show_completed_tasks: "Show my {{count}} completed tasks",
  completed_already_info: "You have completed this already.",
  add_task: "Add task",
  schedule_start: "Start",
  schedule_end: "End",
  schedule_title: "Title",
  schedule_add_row: "Add row",
  schedule_date: "Date",
  schedule_add: "Schedule",
  event_loading: "Event loading...",
  when_ready: "When you are ready...",
  complete_profile: "Please complete your profile",
  not_here_yet: "Not here yet...",
  members: "Members",
  next_up: "Next up",
  lets_go: "Let's go!",
  intro_title: "👋 You are finally here!",
  from_customer_label: "From {{name}}",
  intro_instructions:
    "To get the show started, please complete a few steps below - introduce yourself.",
  button_ready: "I'm ready!",
  button_complete_profile: "Complete profile above",
  button_skip: "Skip for now",
  team: "Team",

  gate_welcome_title: "Welcome!",
  gate_join_instructions: "Join using the email the invite was sent to.",
  gate_error_not_found: "Sorry - not found",
  gate_email_placeholder: "Your email",
  gate_button_confirm: "Confirm email",
  gate_confirmation_info:
    "Since you are here you have received a link to this event. By confirming your email you will be granted access to the content and added as a member to the event.",

  current_team_default_name: "My team",
  team_button_leave: "Leave",
  team_create_label: "Create a team",
  team_create_instructions:
    "Are you creating new memories with others? If so create a team so they can join yours.",
  team_join_label: "Join a team",
  team_join_instructions:
    "Are you creating new memories with any of these teams? If so join them now to connect and to present yourself as part of the team.",
  team_button_join: "Join",
  team_start_own_instructions:
    "If you didn't find any suitable team you can start up your own, so others can join on you easily.",
  team_button_create: "Create team",

  section_button_next: "Next",
  section_title_looks: "Your looks",
  section_label_looks: "Your looks",
  profile_placeholder_display_name: "Set your display name",
  section_title_questions: "Profile questions",
  section_label_questions: "Profile questions",
  profile_placeholder_answer: "Your answer...",
  section_title_presentation: "Presentation",
  section_label_presentation: "Presentation",
  profile_placeholder_presentation: "Present yourself with your own words..",
  section_title_team: "My team",
  screen_title_profile: "Profile",

  feed_filter_by: "Filter by",

  feed_mentions: "Mentions",
  today: "Today",

  mention_people: "People",
  mention_groups: "Groups",
  mention_events: "Events",
  mention_tasks: "Tasks",
  mention_info: "Info",
} as const;

export type BusinessTranslationKeys = keyof typeof business_en;

// const {t} = useTranslation();
// t("business:")
